module.exports = __webpack_public_path__ + "static/img/5.62e2852.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/1/eng/5.png
// module id = mHni
// module chunks = 0